"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbAsisSessionStorageV2 = void 0;
var storage_1 = require("./storage");
Object.defineProperty(exports, "MbAsisSessionStorageV2", { enumerable: true, get: function () { return storage_1.MbAsisSessionStorageV2; } });
//# sourceMappingURL=index.js.map